<template>
  <div class="user-follow por">
    <template v-if="total">
      <div class="user-df-title">我的关注</div>
      <mine-edit v-model="isEdit"
                 :selected="selected.length"
                 del-text="取消关注"
                 @edit-callback="editCb"
                 class="edit"></mine-edit>
      <div class="list flex fww lh1">
        <div class="teacher-info flex csp por" @click="teacherClick(teacher)" v-for="(teacher, i) in list" :key="i">
          <div class="avatar flex aic jcc ovh">
            <img :src="teacher.bigimg" v-df-avatar="defaultTeacherImg" alt="" class="w100 avatar-inner vat">
          </div>
          <div class="info flex-col jce flex-1 por">
            <div class="name wot1">{{teacher.name}}</div>
            <div class="count flex aic">
              <div class="hart-status flex aic" @click="delTeacher(teacher.id, 0, i, $event)">
                <i class="hart mine-ico"></i>
                <span class="status">已关注</span>
              </div>
              <div class="point"></div>
              <div class="number">{{teacher.follow_count || 1}}粉丝</div>
            </div>
            <div class="red-point poa t0 r0" v-show="!isEdit && +teacher.is_add_course === 1"></div>
          </div>
          <div class="edit-checkbox zi1 poa t0 l0 r0" v-show="isEdit">
            <i class="mine-ico abs-m"
               :class="selected.includes(teacher.id) ? 'checkbox-check' : 'checkbox-df'"></i>
          </div>
        </div>
      </div>
      <df-page :total="total" :page-size="limits" :current="curr" @change="changePage"></df-page>
    </template>
    <template v-else-if="total === null">
      <mine-no-data class="no-data w100 abs-m"
                    tips="您还没有关注过任何老师哦~"
                    type="no-follow"
                    hidden-list
                    to-home-text="发现老师"></mine-no-data>
    </template>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import Mixins from '../../mixins/mixins';
  import MineEdit from '../../components/mine/edit';


  export default {
    name: "UserFollow",
    components: {
      MineEdit,
    },
    mixins: [Mixins.AppScroll()],
    // appScroll(e) {
    //   let {height} = e.target.getBoundingClientRect();
    //   let {bottom} = this.$el.getBoundingClientRect();
    //   if (bottom - height / 3 < height && !this.isAllLoad && !this.loading) {
    //     this.curr++;
    //     this.getList();
    //   }
    // },
    watch: {},
    computed: {
      ...mapGetters(['userInfo']),
      isAllLoad() {
        return this.listLength >= this.total && this.total;
      },
      listLength() {
        return this.list.length;
      },
    },
    data() {
      return {
        isEdit: false,

        isLoading: false,
        defaultTeacherImg: require('@/assets/images/details/default_user.png'),

        selected: [],
        list: [],

        curr: 1,
        limits: 24,
        total: 0,
      };
    },
    created() {
      this.getList(1);
    },
    methods: {
      changePage(val, prop){
        if(this.curr === val) return;
        this.curr = val;
        this.getList();
      },
      editCb(type) {
        switch (type) {
          case 'all':
            this.selected = this.list.map(e => e.id);
            break;
          case 'del':
            this.delTeacher();
            break;
          case 'cancel':
            this.selected = [];
            this.isEdit = false;
            break;
        }
      },
      teacherClick(item) {
        if (this.isEdit) {
          if (this.selected.includes(item.id)) {
            this.selected = this.selected.filter(id => id !== item.id);
          } else {
            this.selected.push(item.id);
          }
        } else {
          this.http.NEWUpdateStatus({
            uid: this.userInfo.uid,
            teacher_id: item.id,
            ...this.Product,
          }).then(() => {
            item.is_add_course = 2;
          }).catch(console.log);
          this.OpenRouter('/home/teacher/detail/' + item.id);
        }
      },
      delTeacher(id, i, j, event) {
        if (this.isEdit && id) {
          return;
        }
        event && event.stopPropagation();
        if (id || this.selected.length) {
          let params = {
            teacher_id: (id ? [id] : this.selected) + '',
            uid: this.userInfo.uid,
            ...this.Product,
          };
          this.http.NEWDel(params).then(res => {
            this.ShowToast('删除成功！');
            this.selected = [];
            if (id) {
              this.list.splice(j, 1);
              this.getList('isDel', this.listLength + 1);
            } else {
              this.getList(1);
            }
          }).catch(this.$err);
        }
      },
      getList(init, curr) {
        if(!this.userInfo.uid) return;
        if (this.loading) return;
        this.loading = true;
        if (init !== 'isDel' && init) {
          this.curr = 1;
        }
        this.http.NEWList({
          uid: this.userInfo.uid,
          curr: this.curr,
          limits: this.limits,
          ...this.Product,
          is_web: 1
        }).then(res => {
          if (this.curr === 1 && !curr) {
            this.list = [];
          }
          this.total = res.total || null;
          this.list = res.list;
        }).catch(this.$err).finally(() => {
          this.loading = false;
					//当删除完当页数据，导致查询数据为空是，查询上一页数据
					if(this.total &&this.curr>1 && !this.list.length){
						this.curr--;
						this.getList();
						return
					}
        });
      },
    },
  }
</script>

<style scoped lang="less">
  .user-follow {
    padding: 16px 18px;
    min-height: 100%;
  }

  .list {
    margin-left: -16px;
  }

  .teacher-info {
    margin: 0 0 16px 16px;
    padding: 14px 15px;
    width: 202px;
    height: 84px;
    background-color: #f5f7fb;
    border-radius: 8px;
    .avatar {
      margin-right: 10px;
      width: 56px;
      height: 56px;
      border: 1px solid #ddd;
      border-radius: 50%;
    }
    .name {
      font-size: 18px;
      color: #333f4e;
    }
    .count {
      font-size: 12px;
      color: #666f7a;
      line-height: 0;
      .hart {
        margin-right: 3px;
      }
      .point {
        margin: 0 2px;
        width: 3px;
        height: 3px;
        border-radius: 50%;
        background-color: #999fa6;
      }
      .number {
        color: #999fa6;
      }
    }
    .red-point {
      width: 8px;
      height: 8px;
      background-color: #ff2517;
      border-radius: 50%;
    }
    &:hover {
      background-color: #f5f7fb;

      .name {
        color: #1177ff;
      }
    }
    .hart-status {
      &:hover {
        .hart {
          &:after {
            background-color: #ff5776;
          }
        }
        .status {
          color: #ff5776;
        }
      }
    }
    .edit-checkbox {
      height: 32px;
      line-height: 0;
      .mine-ico {
        right: 8px;
        &:after {
          background-color: #999fa6;
        }
      }
    }
  }

</style>